import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { Settings } from './settings'

export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  beforeLoad: ensureAuthenticatedUser,
  component: Settings,
})
